import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-information',
  templateUrl: 'device-information.component.html',
  styleUrls: ['./device-information.component.scss'],
})

export class DeviceInformationComponent implements OnInit {

  @Input() userDevice: any;

  constructor() {}

  ngOnInit() {}

  get tripImage(): boolean {
    return this.userDevice.device === 3
      ? true
      : this.userDevice.device === 4
      ? true
      : this.userDevice.device === 5
      ? true
      : false;
  }

  get isApple(): boolean {
    return this.userDevice.manufacture === 'Apple' ? true : false;
  }

  get isAndroid(): boolean {
    return this.userDevice.manufacture !== 'Apple' ? true : false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/device-information/device-information/device-information.component.ts